import { computed, unref, watch } from 'vue'

/**
 * Returns a computed ref that is true if any of the provided refs or values are true.
 *
 * @param  {...import('vue').MaybeRef<boolean>} maybeRefs - Any number of boolean refs or values.
 * @returns {import('vue').ComputedRef<boolean>} A computed ref that is true if any input is true.
 */
export function reactiveAny(...maybeRefs) {
  return computed(() => {
    return maybeRefs.map(maybeRef => unref(maybeRef)).some(bool => bool)
  })
}

export function getOnLoadAll(refs, testFn = x => !!x) {
  return (callback) => {
    if (refs.every(x => testFn(unref(x)))) {
      callback(refs.map(unref))
    }
    else {
      const unwatch = watch(
        refs,
        () => {
          if (refs.every(x => testFn(unref(x)))) {
            callback(refs.map(unref))
            unwatch()
          }
        },
        { deep: true },
      )
    }
  }
}

export function getOnLoad(singleRef, testFn = x => !!x) {
  return callback => getOnLoadAll([singleRef], testFn)(vals => callback(vals[0]))
}
